export const filteredConstants = {
	FILTERRECENT: 'FILTEREDRECENT',
	FILTERSERIES: 'FILTEREDSERIES',
	FILTERNAME: 'FILTERNAME',
	FILTERRECENTCONT: 'FILTERRECENTCONT'
}
